"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPropertyItemMonthDayFree = void 0;
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../../models");
var ConfirmPropertyItem_1 = require("../ConfirmPropertyItem");
var shared_1 = require("../shared");
var ConfirmPropertyItemMonthDayFree = function (_a) {
    var month = _a.month, day = _a.day, monthLabel = _a.monthLabel, dayLabel = _a.dayLabel, className = _a.className, color = _a.color, propertyId = _a.propertyId;
    return (react_1.default.createElement(ConfirmPropertyItem_1.ConfirmPropertyItem, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.monthDay, inputFormatType: models_1.MONTH_DAY_PROPERTY_INPUT_TYPE.free, className: className, color: color }, shared_1.isAllStringsFalsy(month, day)
        ? ''
        : "" + month + monthLabel + day + dayLabel));
};
exports.ConfirmPropertyItemMonthDayFree = ConfirmPropertyItemMonthDayFree;
